import { useState, type FormEvent } from 'react';
import type { MeDto } from '@bb/shared';
import { api, ApiError } from '../net/api';
import { Field } from './Field';

/** Second sign-in step for accounts with two-step on: the app code, or a recovery code. */
export function TwoStepCode({ ticket, onDone, onBack }: { ticket: string; onDone: (me: MeDto) => void; onBack: () => void }) {
  const [error, setError] = useState<string>();
  const [busy, setBusy] = useState(false);
  async function submit(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();
    setBusy(true);
    setError(undefined);
    try {
      onDone(await api.loginCode(ticket, String(new FormData(e.currentTarget).get('code') ?? '')));
    } catch (err) {
      if (err instanceof ApiError && err.code === 'ticket_invalid') onBack();
      setError((err as Error).message);
    } finally {
      setBusy(false);
    }
  }
  return (
    <form onSubmit={submit} noValidate>
      <p className="muted small-print">Two-step verification is on. Enter the 6-digit code from your authenticator app, or one of your recovery codes.</p>
      <Field id="two-step-code" name="code" label="Code" autoComplete="one-time-code" inputMode="text" required autoFocus />
      {error && <p className="form-error" role="alert">{error}</p>}
      <button className="btn wide" disabled={busy}>Sign in</button>
      <button type="button" className="link-btn small-print" onClick={onBack}>Back</button>
    </form>
  );
}
